import { useParams } from "react-router";
import { DocumentBlobCard } from "@/services/backend/filestorage/components/document-blob-card";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";

export function OfferFilesRoute() {
  const { offerId } = useParams();

  return (
    <DocumentBlobCard
      subdomain="omni"
      documentKind={GSMDocumentKind.Offer}
      documentId={offerId!}
      accept="application/pdf,image/jpeg,image/png"
    />
  );
}
